import { BenefitType } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

import { EmployeePagePlansBenefitCardDentalPlanElectionDrawer } from './EmployeePagePlansBenefitCardDentalPlanElectionDrawer';
import { EmployeePagePlansBenefitCardMedicalPlanElectionDrawer } from './EmployeePagePlansBenefitCardMedicalPlanElectionDrawer';
import { EmployeePagePlansBenefitCardVisionPlanElectionDrawer } from './EmployeePagePlansBenefitCardVisionPlanElectionDrawer';

type Props = {
  onboardingPeriodId: string;
  employeeId: string;
  isOpen: boolean;
  onClose: () => void;
  benefitType?: BenefitType;
  benefitId?: string;
};

export const EmployeePagePlansBenefitCardPlanElectionDrawer = ({
  onboardingPeriodId,
  benefitType,
  employeeId,
  benefitId,
  isOpen,
  onClose,
}: Props) => {
  return $enum.mapValue(benefitType).with({
    [BenefitType.MAJOR_MEDICAL]: (
      <EmployeePagePlansBenefitCardMedicalPlanElectionDrawer
        onboardingPeriodId={onboardingPeriodId}
        employeeId={employeeId}
        benefitId={benefitId}
        onClose={onClose}
        isOpen={isOpen}
      />
    ),
    [BenefitType.SUPPLEMENTAL_DENTAL]: (
      <EmployeePagePlansBenefitCardDentalPlanElectionDrawer
        onboardingPeriodId={onboardingPeriodId}
        employeeId={employeeId}
        benefitId={benefitId}
        onClose={onClose}
        isOpen={isOpen}
      />
    ),
    [BenefitType.SUPPLEMENTAL_COMBINED_DENTAL_VISION]: (
      <EmployeePagePlansBenefitCardDentalPlanElectionDrawer
        onboardingPeriodId={onboardingPeriodId}
        employeeId={employeeId}
        benefitId={benefitId}
        onClose={onClose}
        isOpen={isOpen}
      />
    ),
    [BenefitType.SUPPLEMENTAL_VISION]: (
      <EmployeePagePlansBenefitCardVisionPlanElectionDrawer
        onboardingPeriodId={onboardingPeriodId}
        employeeId={employeeId}
        benefitId={benefitId}
        onClose={onClose}
        isOpen={isOpen}
      />
    ),
    [BenefitType.SUPPLEMENTAL_ACCIDENT]: undefined,
    [BenefitType.SUPPLEMENTAL_ACCIDENTAL_DEATH_AND_DISMEMBERMENT]: undefined,
    [BenefitType.SUPPLEMENTAL_CRITICAL_ILLNESS]: undefined,
    [BenefitType.SUPPLEMENTAL_FLEXIBLE_SPENDING_ACCOUNT]: undefined,
    [BenefitType.SUPPLEMENTAL_HOSPITAL]: undefined,
    [BenefitType.SUPPLEMENTAL_LIFE]: undefined,
    [BenefitType.SUPPLEMENTAL_OTHER]: undefined,
    [$enum.handleUnexpected]: undefined,
    [$enum.handleUndefined]: undefined,
  });
};
